import { takeEvery, put, select } from 'redux-saga/effects';
import pick from 'lodash/pick';
import employeesListActions from '../actionTypes/employeesActions';
import { API_CALL } from '../actionTypes/sharedActions';
import { GET_EMPLOYEES_LIST, DELETE_EMPLOYEE } from '../routes';

const getCompanyId = (state) => {
  return state.loginReducer.currentUser.resourceable_id;
};

const getFilters = (state) => {
  return pick(state.employeesListReducer, ['per', 'page', 'query']);
};

function* getEmployeesList({ payload }) {
  const id = yield select(getCompanyId);
  const filters = yield select(getFilters);
  yield put({
    type: API_CALL,
    payload: {
      url: GET_EMPLOYEES_LIST.replace(':company_id', id),
      method: 'POST',
      data: { per: 10, page: 1, ...filters },
    },
    successAction: employeesListActions.getEmployeesListSuccess,
    failureAction: employeesListActions.getEmployeesListFailed,
  });
}

function* deleteEmployee({ payload }) {
  const { id } = payload;
  const companyId = yield select(getCompanyId);

  yield put({
    type: API_CALL,
    payload: {
      url: DELETE_EMPLOYEE.replace(':id', id).replace(':company_id', companyId),
      method: 'DELETE',
      data: payload,
    },
    successAction: employeesListActions.deleteEmployeeSuccess,
    failureAction: employeesListActions.deleteEmployeeFailed,
  });
}

export default function* watchEmployeesList() {
  yield takeEvery(employeesListActions.getEmployeesList, getEmployeesList);
  yield takeEvery(employeesListActions.addNewEmployeeSuccess, getEmployeesList);
  yield takeEvery(
    employeesListActions.updateEmployeeDetailsSuccess,
    getEmployeesList
  );
  yield takeEvery(
    employeesListActions.deleteEmployee,
    deleteEmployee,
  );
  yield takeEvery(
    employeesListActions.deleteEmployeeSuccess,
    getEmployeesList,
  );
}
